import { RefreshTypeEnum } from '../inputs';
import { ICompany } from './company.repository';
import { ILinkedinProfile } from './linkedin-profile.repository';
import { IRefreshQueue } from './refresh-queue.repository';
import { IWebhook } from './webhooks.repository';

export interface IRefreshQueueItem {
  _id: string;
  queue: string | IRefreshQueue;

  linkedinId: string;

  type: RefreshTypeEnum;
  status: RefreshQueueItemStatus;

  attemptCount: number;
  documentId: string | ILinkedinProfile | ICompany;
  nextAttempt: Date;
  failedWebhookIds: (string | IWebhook)[];
  failedWebhookReasons: string[];

  createdAt: string;
  updatedAt: string;
}

export type INewRefreshQueueItem = Omit<
  IRefreshQueueItem,
  '_id' | 'failedWebhookIds' | 'failedWebhookReasons' | 'nextAttempt' | 'documentId' | 'createdAt' | 'updatedAt'
>;

export enum RefreshQueueItemStatus {
  Pending,
  Refreshing,
  Failed
}

export interface IRefreshQueueItemToUpdate {
  _id: string;
  failedWebhookIds: string[];
  failedWebhookReasons: string[];
  documentId: string;
  nextAttempt: Date;
  attemptCount: number;
}
